import { createContext, useContext, useRef } from "react";

const FooterPlayerContext = createContext(null);

export const FooterPlayerProvider = ({ children }) => {
  const footerPlayerRef = useRef(null);

  return (
    <FooterPlayerContext.Provider value={{ footerPlayerRef }}>
      {children}
    </FooterPlayerContext.Provider>
  );
};

export const useFooterPlayer = () => {
  const context = useContext(FooterPlayerContext);

  if (!context) {
    throw new Error("useFooterPlayer must be used within FooterPlayerProvider");
  }

  return context;
};
